import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconValidateShield24 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		children: [/* @__PURE__ */ _jsx("path", { d: "m16.707 9.207-1.414-1.414-4.367 4.367-1.801-1.44-1.25 1.56 3.2 2.56z" }), /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M4 15V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-.8 1.6l-6 4.5a2 2 0 0 1-2.4 0l-6-4.5A2 2 0 0 1 4 15m2 0V5h12v10l-6 4.5z",
			clipRule: "evenodd"
		})]
	})
});
const ForwardRef = forwardRef(SvgIconValidateShield24);
export default ForwardRef;
